import { Box, Button, CircularProgress } from '@mui/material'
import React from 'react'
import Results from './Results'
import Search from './sortingFilter/Search'

export default function Sidebar ({ props }) {
  const { handleZoom, handleResultComponent, resultComponent, nearByCenters, currLocation, point } = props
  const originLocation = point || currLocation
  return (
    <div className={resultComponent ? 'hide-locations-panel' : 'locations-panel'}>

      <div className='sticky-panel'>
        <Search handleResultComponent={() => handleResultComponent(false)} />
      </div>

      {/* <button data-toggle='tooltip' title={resultComponent ? 'Open' : 'Close'} onClick={() => handleResultComponent(!resultComponent)} className={resultComponent ? 'open-btn list-btn' : 'close-btn list-btn'} /> */}

      {originLocation && nearByCenters
        ? <Results props={{ handleResultComponent, handleZoom, resultComponent, nearByCenters, originLocation }} />
        : (!point && !currLocation)
            ? <div className='results-list allow-location'>
              <span style={{ marginTop: '30px', fontSize: '70px' }} className='material-symbols-outlined'> error </span>
              <h2> Please allow location access or Search your location!</h2>
            </div>
            : <Box className='results-list' sx={{ marginTop: '10vh', display: 'flex', justifyContent: 'center' }}>
              <CircularProgress />
              </Box>}

      <Button color='inherit' sx={{ mx: 0, background: 'white' }} variant='outlined' className='map-list-btn' onClick={() => handleResultComponent(!resultComponent)}>
        <span className='material-symbols-outlined'>
          {resultComponent ? 'list' : 'map'}
        </span>
        {resultComponent ? 'View List' : 'View Map'}
      </Button>
    </div>
  )
}
